import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@systemeio/components';
import { Hint } from 'shared/components';
import { useSubstitutes } from 'shared/components/dashboard-mail-editor/hooks/use-substitutes';
import { DashboardMailEditorCommonProps } from '../types/common';
export interface SubstituteInterface {
  slug: string;
  name: string;
}
export interface SubstitutesBlockProps extends Pick<DashboardMailEditorCommonProps, 'inModal'> {
  additionalSubstitutes?: SubstituteInterface[];
}
const SubstitutesBlock = t0 => {
  const $ = _c(3);
  const {
    additionalSubstitutes
  } = t0;
  const {
    substitutionData,
    isReady
  } = useSubstitutes(additionalSubstitutes);
  let t1;
  if ($[0] !== isReady || $[1] !== substitutionData) {
    t1 = isReady ? <ul className="flex flex-col gap-3">{substitutionData.map(_temp)}</ul> : <EmailSubstitutesSkeleton />;
    $[0] = isReady;
    $[1] = substitutionData;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const EmailSubstitutesSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex animate-pulse flex-col gap-3"><Skeleton className="rounded-sm text-transparent">.</Skeleton><Skeleton className="rounded-sm text-transparent">.</Skeleton><Skeleton className="rounded-sm text-transparent">.</Skeleton><Skeleton className="rounded-sm text-transparent">.</Skeleton><Skeleton className="rounded-sm text-transparent">.</Skeleton><Skeleton className="rounded-sm text-transparent">.</Skeleton><Skeleton className="rounded-sm text-transparent">.</Skeleton><Skeleton className="rounded-sm text-transparent">.</Skeleton><Skeleton className="rounded-sm text-transparent">.</Skeleton><Skeleton className="rounded-sm text-transparent">.</Skeleton><Skeleton className="rounded-sm text-transparent">.</Skeleton><Skeleton className="rounded-sm text-transparent">.</Skeleton><Skeleton className="rounded-sm text-transparent">.</Skeleton></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default SubstitutesBlock;
function _temp(el) {
  return <li key={el.value} className="flex flex-wrap gap-1"><span className="text-text-error whitespace-nowrap">{el.value}</span>-{el.hint ? <Hint ariaLabel={el.label} label={el.hint}>{el.label}</Hint> : <span>{el.label}</span>}</li>;
}